import { reactive, ref, computed } from 'vue';
import store from "@/store";
import { getStructure } from "@/request/view/personal";
import { Toast } from '@/utils';

type modeStd = null | 'staff' | 'department' | 'staffAndLeader';

type staffSelectValue = {
    staffId: null | string,
    staffName: null | string,
    leaderId?: null | string,
    leaderName?: null | string,
    department?: null | string,
    departmentId?: null | string,
}

interface staffDataStd {
    mode: modeStd,
    selected: Array<staffSelectValue>,
    multiple: boolean,
}

type user = {
    entryTime: string,
    firstLevelDepartment: string,
    id: number,
    isDL: boolean,
    jobNumber: string,
    nickName: string,
    notes: string,
    password: string,
    pid: number,
    post: string,
    reportTo: string,
    secondaryDepartment: string,
    structureId: number,
    username: string
}

interface structure {
    id: number,
    pid: number,
    structureName: string,
    children?: Array<structure>,
    userList?: Array<user>,
}

const setNoticeStaffData = (list: Array<structure>) => {
    if (!list.length || list.length === 0) return;
    store.commit("SET_NOTICE_STAFF_DATA", list);
};

// 将用户置入
const setStructureBuyUser = (list) => {
    list.forEach((item) => {
        item.structureName = item.nickName;
        item.id = `P${item.id}`;
    });
    return list;
};

// 获取服务器中的数据
const getNoticeStaffByRequest = (): Promise<Array<structure>> => {
    return new Promise((resolve, reject) => {
        getStructure().then((res) => {
            if (res.code === 200) {
                const flatten = (list: Array<structure>) => {
                    list.forEach((item) => {
                        if (item.userList && item.userList.length > 0) {
                            item.children.unshift(...setStructureBuyUser(item.userList));
                        }
                        if (item.children && item.children.length > 0) {
                            flatten(item.children);
                        }
                    });
                };

                flatten(res.data);
                resolve(res.data);
            }
        });
    });
};

// 获取session中通知员工数据
const getNoticeStaffBySession = (): Promise<string> => {
    return new Promise((resolve, reject) => {
        const noticeStaffData = sessionStorage.getItem("noticeStaffData");
        resolve(noticeStaffData);
    });
};


// 初始化数据
export const initOptionsData = async () => {
    // const sessionStaffData = await getNoticeStaffBySession();
    // if (sessionStaffData !== null) {
    //     setNoticeStaffData(JSON.parse(sessionStaffData));
    //     return;
    // }

    const requestStaffData = await getNoticeStaffByRequest();
    setNoticeStaffData(requestStaffData);
    sessionStorage.setItem(
        "noticeStaffData",
        JSON.stringify(requestStaffData)
    );
};

/**
 * 
*/
export const useStaff = () => {
    /**
     * mode: staff(选择员工) department(选择部门) staffAndLeader(选择员工和领导)
     * leader: 领导
     * staff: 员工
     * mutiple: 多选
    */
    const data: staffDataStd = reactive({
        mode: null,
        selected: [],
        multiple: false,
    });
    // 默认展开的数据
    const treeDefaultExpandedKeys = ref([1]);

    // 供选择数据
    const options = computed<Array<structure>>(() => store.state.noticeStaffData);

    const fliterStaff = () => {
        const ite = (list: Array<structure>) => {
            list.forEach((item) => {
                item.children = item.children.filter((f) => String(f.id).indexOf("P") === -1)
                if (item.children && item.children.length > 0) {
                    ite(item.children);
                }
            });
            return list;
        }

        const departmentList = ite(options.value);

        console.log(departmentList, 'list data is ?');
    };

    // 更新选择数据
    const updateStaffData = async (options: staffDataStd) => {
        const { mode, multiple } = options;

        if (mode !== undefined) {
            data.mode = mode;
        }

        if (mode === 'department') {
            fliterStaff();
        } else {
            initOptionsData();
        }

        if (multiple !== undefined) data.multiple = multiple;

    };

    // 搜索员工
    const searchStaff = (inputValue: string, treeNode) =>
        treeNode.props.structureName.indexOf(inputValue) !== -1;

    // 寻找部门领导
    const findDepartMentLeader = (firstLevelDepartment: string) => {
        let leader = null;
        let structure = null;

        const list = options.value;

        const structureCondition = (item) => {
            if (item.structureName === firstLevelDepartment) {
                structure = item;
            }
        };

        const leaderCondition = (item) => {
            if (structure && structure.id === item.structureId && item.isDL) {
                leader = item;
            }
        };

        const ite = (list, fn) => {
            list.forEach((item) => {
                fn(item);
                if (item.children && item.children.length > 0) {
                    ite(item.children, fn);
                }
            });
        };

        ite(list, structureCondition);
        ite(list, leaderCondition);

        return leader;
    };

    const resetSelect = () => {
        data.selected.length = 0;
    };

    // 选中人员
    const chooseStaff = (value, node, extra) => {
        if (String(value).indexOf('P') === -1) {
            return Toast('warning', '请选择人员', 3);
        }
        const staffId = value.toString().replace(/P/g, "");

        const staffName = node.dataRef.nickName;

        data.selected.push({
            staffId,
            staffName,
        });
    };
    // 选择部门
    const chooseDepartment = (value, node, extra) => {

    };
    // 选择人员和部门领导
    const chooseStaffAndLeader = (value, node, extra) => {
        if (String(value).indexOf('P') === -1) {
            return Toast('warning', '请选择人员', 3);
        }
        const staffId = value.toString().replace(/P/g, "");

        const { nickName, firstLevelDepartment } = node.dataRef;

        const leader = findDepartMentLeader(firstLevelDepartment);

        const selectVal = {
            staffId,
            staffName: nickName,
            leaderId: null,
            leaderName: null,
        };

        if (leader) {
            selectVal.leaderId = leader.id.toString().replace(/P/g, "");
            selectVal.leaderName = leader.nickName;
        }

        data.selected.push(selectVal);
    };
    /**
     * 策略模式
     * 
    */
    const staffSelectStrategy = {
        staff: chooseStaff,
        department: chooseDepartment,
        staffAndLeader: chooseStaffAndLeader,
    };

    // 选中数据
    const handleSelectValue = (value, node, extra) => {
        const mode = data.mode;
        if (!mode) {
            throw new Error('检查mode参数');
        }
        resetSelect();
        staffSelectStrategy[mode](value, node, extra);
    };

    const handleChooseStaffChange = (value, label, extra) => {

    };
    // 清除选择
    const clearSelect = () => {

    };

    // 回显数据
    const echoFormData = (nameList: Array<string>, idList: Array<string>) => {
        if (nameList.length !== idList.length) return new Error('请检查参数');
    };

    // 初始化数据
    const initOptionsData = async () => {
        const sessionStaffData = await getNoticeStaffBySession();

        if (sessionStaffData !== null) {
            setNoticeStaffData(JSON.parse(sessionStaffData));
            return;
        }

        const requestStaffData = await getNoticeStaffByRequest();
        setNoticeStaffData(requestStaffData);
        sessionStorage.setItem(
            "noticeStaffData",
            JSON.stringify(requestStaffData)
        );
    };

    return {
        options,
        data,
        treeDefaultExpandedKeys,
        clearSelect,
        searchStaff,
        echoFormData,
        initOptionsData,
        updateStaffData,
        handleSelectValue,
        findDepartMentLeader,
        handleChooseStaffChange,
    }
};
